class HeaderMenu {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    $(window).scroll(function () {
      if($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        $('html').removeClass('is-scroll');
      }
    });
    
    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      $('.js-mega-btn').click(function () {
        $('.js-mega-menu').slideToggle('.js-mega-menu');
        $('.js-mega-trigger').toggleClass('is-active');
        $('.js-mega-btn').toggleClass('is-active');
      });
    } else {
      $('.js-mega-trigger').hover(function() {
        $('.js-mega-menu').addClass('is-active');
        $(this).find('div').addClass('is-active');
      }, function() {
        $('.js-mega-menu').removeClass('is-active');
        $(this).find('div').removeClass('is-active');
      });

      $('.js-mega-menu').hover(function() {
        $(this).addClass('is-active');
      }, function() {
        $(this).removeClass('is-active');
      });
    
    }

    var currentPath = window.location.pathname;  
    if (currentPath === '/') {
      // console.log("トップ");
      $('.c-contact').addClass('is-top');      
    } else {
      // $('.js-header').addClass('is-active');
    }
  

    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      if ($('html').hasClass('is-open')) {
        $(".js-drawer-text").text("閉じる");
        $(".js-fixed-banner").addClass("no-active");
      } else {
        $(".js-drawer-text").text("メニュー");
        $(".js-fixed-banner").removeClass("no-active");
      }
      fixedBody();
    });
    
    const body = $('body');
    let status = false;
    let pos = 0;
  
    function fixedBody() {
      if (!status) {
        pos =
          window.scrollY ||
          window.scrollTop ||
          document.getElementsByTagName('html')[0]?.scrollTop ||
          0;
  
        body.addClass('fixed');
        $('body').css('top', -pos + 'px');
        status = true;
      } else {
        body.removeClass('fixed');
        $('body').css('top', '0');
        window.scrollTo(0, pos);
        status = false;
      }
    }
  }
}
